/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'menu-profile': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="#203F6A" fill-rule="evenodd" d="M8 0a8.004 8.004 0 00-5.657 2.343 8.004 8.004 0 000 11.314 8.004 8.004 0 0011.314 0A8.004 8.004 0 0016 8a8.005 8.005 0 00-2.346-5.654A8.005 8.005 0 008 0zm0 1.306v.001a6.696 6.696 0 016.638 5.838 6.698 6.698 0 01-1.089 4.597 6.525 6.525 0 00-2.976-2.568 3.591 3.591 0 10-5.147 0 6.533 6.533 0 00-2.975 2.573A6.692 6.692 0 018 1.307v-.001zM5.714 6.674a2.285 2.285 0 013.901-1.62A2.287 2.287 0 018 8.956a2.29 2.29 0 01-2.286-2.283zM3.348 12.8a5.255 5.255 0 012.675-2.474c.276-.118.562-.208.856-.273a3.29 3.29 0 002.242 0c.302.06.596.148.88.264a5.243 5.243 0 012.664 2.471 6.663 6.663 0 01-9.303 0l-.014.012z"/>'
  }
})
